module.exports = __webpack_public_path__ + "img/pubscholar.4aa083ca.png";